import { OperationResult, OperationStatus } from '../types';

export interface User extends Record<string, unknown> {
  email?: { value: string; verified: boolean };
  familyName?: string;
  givenName?: string;
  idpId?: string;
  idpType?: string;
  locale?: string;
  phoneNumber?: { value: string; verified: boolean };
  userName?: string;
}

export interface UserInitialState {
  user: User;
  getUser: OperationResult;
}

export const initialState: UserInitialState = {
  getUser: {
    status: OperationStatus.NOT_STARTED,
    error: null
  },
  user: {}
};
